var frameThrottle = require("enyo-perf/utils").frameThrottle,
    get           = require("object-path").get,
    kind          = require("enyo/kind");

require("app/ui/RevolutionSlider.less");
require("app/theme/IconButton--slider.less");

/**
 * [ImageSlider]{@link app.ui.ImageSlider} displays a horizontal slideshow of
 * [ImageSlides]{@link app.ui.ImageSlide}.
 *
 * @ui
 * @class    app.ui.RevolutionSlider
 * @extends  app.ui.Slider
 * @public
 */
module.exports = kind(/** @lends  app.ui.RevolutionSlider.prototype */ {

    /**
     * @private
     */
    name: "app.ui.RevolutionSlider",

    /**
     * @private
     */
    classes: "app-ui-revolution-slider",

    /**
     * @private
     */
    components: [{
        name:       "iframe",
        tag:        "iframe",
        attributes: {
            frameborder:     "0",
            allowfullscreen: false,
            scrolling:       "no"
        },
        classes: "app-ui-revolution-slider__iframe enyo-fit"
    }],

    /**
     * @private
     */
    observers: {
        update: ["state"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var state = this.state || {},
            src   = get(state, "revolution_slider_url", null);

        this.$.iframe.setAttribute("src", src);
    }
});
